var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow2Up = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10.334 7.667 9.333 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.584 21.082V9.616l3.123 3.136c.22.22.576.22.795 0a.566.566 0 0 0 0-.799l-4.104-4.121a.56.56 0 0 0-.795 0l-4.104 4.121a.566.566 0 0 0 0 .799c.219.22.575.22.795 0l3.123-3.136v11.466c0 .317.262.585.584.585a.59.59 0 0 0 .583-.585"
})));
export default SvgArrow2Up;